import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MarketingLandingPage from './pages/MarketingLandingPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MarketingLandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}